import { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Container, StyledFormLabel } from "./CommonStyles";
import MTF from "../form/multi-text-field/MultiTextField";

export interface MultiTextFieldProps {
    label: string;
    id: string;
    description?: string;
    value?: string[];
    additionalInfo?: string;
    fontWeightBold?: boolean;
}

/**
 * multi-text input field for edit entry form
 */
export const MultiTextField = forwardRef<any, MultiTextFieldProps>((props: MultiTextFieldProps, ref) => {
    const { label, id, description, value, additionalInfo, fontWeightBold } = props;

    const { control } = useFormContext();

    return (
        <Container>
            <StyledFormLabel
                id={`label_${id}`}
                text={label}
                description={description}
                additionalInfo={additionalInfo}
                fontWeightBold={fontWeightBold}
            />
            <Controller
                control={control}
                name={id as "dummy"}
                defaultValue={value || []}
                render={({ field: { onChange, onBlur, value } }) => (
                    <MTF
                        id={id}
                        ariaLabelledby={`label_${id}`}
                        value={value}
                        ref={ref}
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                )}
            />
        </Container>
    );
});
